import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterRoleHistoryLayer from "../components/ChapterRoleHistoryLayer";

const ChapterRoleHistoryPage = () => {
    return (
        <MasterLayout>
            <ChapterRoleHistoryLayer />
        </MasterLayout>
    );
};

export default ChapterRoleHistoryPage;
